import { ReviewCategory } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export interface CategoryReview {
  category: ReviewCategory | string
  rating: number
  comment?: string
}

interface GetOverallRatingProps {
  categoryReviews: CategoryReview[]
  isSourceAvantStay: boolean
}

export const getOverallRating = ({ categoryReviews, isSourceAvantStay }: GetOverallRatingProps) => {
  const overallRating = categoryReviews.find(review => {
    return isSourceAvantStay
      ? review.category === ReviewCategory.nps
      : review.category === ReviewCategory.overall
  })

  return overallRating
}
